<template>
  <div class="info_warp">
    <TopCard ref="TopCardRef"
             text="线上答疑"
             :showBack="true" />
    <!-- <div class="huifu_btn"
         @click="huifu">
      回复
    </div> -->
    <div class="wrap">
      <div class="tiwen">
        <div class="head">
          <div>
            <img src="@/assets/dayi/tx.png"
            style="width: 60rem;height: 60rem;"
                 alt="" />
                 <div style="display: flex;flex-direction: column;gap: 8rem;">
            <div class="text">{{ info.discuss_parent.discuss_title || '' }}</div>

            <div class="subject" :style="{'background':boardBackg[info.discuss_parent.board_id]?boardBackg[info.discuss_parent.board_id].background:''}">{{ info.discuss_parent.board_name || '' }}</div>
            </div>
          </div>
          
        </div>
        <div class="content">
          <div class="left">
            {{ info.discuss_parent.discuss_content }}
            <div class="images">
              <el-image style="width: 120rem; height: 120rem;border-radius:10rem;"
                        v-for="(item, index) in info.discuss_parent.discuss_image"
                        :key="index"
                        :src="item"
                        :preview-src-list="info.discuss_parent.discuss_image">
              </el-image>
            </div>
         
          </div>
          <div class="bottom">
                <div>
            {{ info.discuss_parent.discuss_time }}
          </div>
          <div class="btn">
            <div class="right">
              <div>
              <img src="@/assets/dayi/icon-未点赞@2x.png"
                   @click="dianzan"
                   v-if="show"
                   alt="" />
              <img src="@/assets/dayi/icon-已点赞@2x.png"
                   v-else
                   alt="" />
              <span>
                {{ info.discuss_parent.discuss_upvote_times }}
              </span>
              </div>
              <div style="margin-left: 36rem;">
                <img src="@/assets/dayi/pl.png"
                   alt="" />
                  <span>  {{info.discuss_parent.discuss_re_times}} </span>
                       </div>
            </div>
          </div>
           </div>
        </div>

        <!-- associated question -->
        <div class="associated_question"
             v-if="info.discuss_parent.question_data">

          <div class="header">
            <div class="button"
                 @click="isShowAssociatedQuestion = !isShowAssociatedQuestion">
              <div class="button-item"
                   v-show="isShowAssociatedQuestion">
                <div>查看题目</div>
                <img style="width: 20rem; height: 13rem"
                     src="@/assets/dayi/pull-down.png"
                     alt="" />
              </div>
              <div class="button-item"
                   v-show="!isShowAssociatedQuestion">
                <div>隐藏题目</div>
                <img style="width: 20rem; height: 13rem"
                     src="@/assets/dayi/pull-up.png"
                     alt="" />
              </div>
            </div>
          </div>
          <div class="body"
               v-show="!isShowAssociatedQuestion">
            <div class="title">题目内容(ID:{{info.discuss_parent.question_id}})</div>
            <div class="content border-radius contentBlock">
              <div v-html="info.discuss_parent.question_data.question_head_content"></div>
            </div>
            <div class="content contentBlock"
                 v-html="info.discuss_parent.question_data.question_content"></div>
            <div class="title">题目答案</div>
            <div class="content border-radius contentBlock"
                 v-html="info.discuss_parent.question_data.question_answer"></div>
            <div class="title">题目解析</div>
            <div class="content contentBlock"
                 v-html="info.discuss_parent.question_data.question_explain">
            </div>
          </div>

        </div>
      </div>

      <div class="tiwen"
            
           v-if="info.discuss_parent.review_status === -1">
        <div class="head">
          <div>
            <img src="@/assets/dayi/tx.png"
                 alt="" />
            {{ info.discuss_parent.discuss_title || '' }}
          </div>
          <div>
            {{ info.discuss_parent.review_time }}
          </div>
        </div>

        <div class="reject_warp">
          <div class="reject_content">
            未通过原因:{{info.discuss_parent.reason}}
          </div>
          <div class="reject_btn">
            审核不通过
          </div>
        </div>
      </div>
 <div class="textarea">
         <div style="display: flex;gap: 20rem;">  <div> <img src="@/assets/dayi/tx.png"
                style="width:40rem;height:40rem"
                     alt="" /></div>
                     <div style="width: 80%;">
          <el-input placeholder="发布你的回复"
                        
                        v-model="discuss_content"
                        type="textarea"
                        rows="2" />
      </div>
        </div>
      <div style="display: flex;justify-content: space-between;margin-top: 20rem;">
        <div style="margin-left: 60rem;"  >
         
            <div class="images" v-show="isShow">
                <div v-for="(item,index) in images"
                     :key="item">
                  <span>
                    <img src="@/assets/del.png"
                         @click="delImage(index)"
                         alt="">
                  </span>
                  <img :src="item"
                       style=" width:90rem;height: 90rem;margin-right:10rem"
                       alt="">
                </div>
                <div class="add_img"
                     v-if="images.length  != 2"
                     @click="uploadImage">
                  <img src="@/assets/add_imgi.png"
                       alt="">
                </div>
              </div>
          <img src="@/assets/dayi/pic.png" style="width: 20rem;height: 20rem;"
          @click="uploadimg"
                 alt="">
          </div>
    
      <div class="btn" @click="topost">评论</div>  
      </div>
       </div>
      <div class="common"
           v-if="info.volist_children.length">
        <div class="huida"
             v-for="(item, index) in info.volist_children"
             :key="index">
          <div class="head">
            <div style="color: var(--Brand-Color_6default, #2196F3);font-size: 16rem;">
              <img src="@/assets/dayi/tx.png"
                   alt="" />
              {{ item.user_id }}
            </div>
            
          </div>
          <div class="content">
            <div class="left">
              <div v-html="item.discuss_content">
              </div>
              <div class="btn">
                <div class="images">
                  <el-image style="width: 80rem; height: 80rem"
                            v-for="(item, index) in item.discuss_image"
                            :key="index"
                            :src="item"
                            :preview-src-list="item.discuss_image">
                  </el-image>
                </div>
              </div>
            </div>
           
            <div class="right">
                 <div>
              {{ item.discuss_time }}
            </div>
            <div style="display: flex;justify-content: center;align-items: center;gap:46rem">
             <div style="display: flex;justify-content: center;align-items: center;"> <img src="@/assets/dayi/icon-未点赞@2x.png"
                   @click="dianzanChild(item, index)"
                   v-if="item.show"
                   alt="" />
              <img src="@/assets/dayi/icon-已点赞@2x.png"
                   v-else
                   alt="" />
              <span>
                {{ item.discuss_upvote_times }}
              </span>
               </div>
               <div style="display: flex;justify-content: center;align-items: center;">
              <img src="@/assets/dayi/pl.png"
                   alt="" />
                  <span>  {{item.discuss_re_times}} </span>
            </div>
             </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- v-if="info.discuss_parent.review_status !== -1" -->
    <!-- <div class="fixed_btn"
         @click="huifu">
      回 复
    </div> -->
    <HuifuForm ref="HuifuFormRef" />
  </div>
</template>

<script>
import HuifuForm from './huifu.vue';
import TopCard from '@/views/components/top_card/index.vue'
import { uploadImageAuto } from '@/api/upload.js'

export default {
  data () {
    return {
       boardBackg: {
        1: {
        background: '#F67171',
          url: require(`@/assets/discuss/icon-语文@2x.png`)
        },
        2: {
          background: '#FF7745',
          url: require(`@/assets/discuss/icon-数学@2x.png`)
        },
        3: {
          background: '#6C67F9',
          url: require(`@/assets/discuss/icon-英语@2x.png`)
        },
        4: {
          background: '#FFA800',
          url: require(`@/assets/discuss/icon-物理@2x.png`)

        },
        5: {
          background: '#5EE5A0',
          url: require(`@/assets/discuss/icon-化学@2x.png`)

        },
        6: {
          background: '#2DB6FF',
          url: require(`@/assets/discuss/icon-生物@2x.png`)
        },
        // 地理
        7: {
          background: '#2DB6FF',
          url: require(`@/assets/discuss/icon-生物@2x.png`)
        },
        // 历史
        8: {
          background: '#FDB638',
          url: require(`@/assets/discuss/icon-物理@2x.png`)
        },
        // 政治
        9: {
          background: '#5EE5A0',
          url: require(`@/assets/discuss/icon-化学@2x.png`)
        },
        10: {
          background: '#FFD34B',
          url: require(`@/assets/discuss/icon-服务区@2x.png`)
        }
      },
      discuss_content: '',
       images: [],
      info: {
        discuss_parent: {
          discuss_title: '',

        },
           
        question_data: {
          question_content: ''
        },
        volist_children: []
      },
      show: true,
      isShowAssociatedQuestion: true,
      isShow:false
    };
  },
  components: {
    HuifuForm, TopCard
  },
  mounted () {
    this.getTieziInfo();
  },
  methods: {
     async uploadImage () {
      const { data } = await uploadImageAuto()
      this.images.push(data.info.dir)
      this.isShow = true
    },
    addImage (str) {
      if (!str) {
        this.$message.warning('失败')
        return
      }
      this.images.push(this.$addHeader(str))
    },
    delImage (index) {
      this.images.splice(index, 1)
    },
    getTieziInfo () {
      this.$http({
        url: '/api/v1/discuss/show_post',
        method: 'get',
        params: {
          discuss_id: this.$route.query.discuss_id,
          is_pc: 1
        }
      }).then(res => {
        res.data.discuss_parent.discuss_image = res.data.discuss_parent.discuss_image
          ? JSON.parse(res.data.discuss_parent.discuss_image)
          : [];
        res.data.volist_children = res.data.volist_children.map(item => {
          item.show = true;
          return item;
        });

        res.data.volist_children.map(item => {
          item.discuss_image = item.discuss_image ? JSON.parse(item.discuss_image) : [];
          return;
        });
        this.info = res.data;
      });
    },
    uploadimg (file) {
      this.uploadImage()
    },
    topost () {
          let form = {}
          form.discuss_content = this.discuss_content
          form.discuss_parent_id = this.$route.query.discuss_id
        form.discuss_image = this.images.join(',')
        this.$http({
          url: '/api/v1/discuss/re_post_done',
          method: 'post',
          data: form
        }).then(res => {
          this.$message.success('发帖成功')
         this.discuss_content = ''
          this.images = []
          this.isShow=false
          this.getTieziInfo()
        })
      
 
    },
    dianzan () {
      this.$http({
        url: '/api/v1/discuss/add_upvote',
        method: 'post',
        data: {
          discuss_id: this.info.discuss_parent.discuss_id
        }
      }).then(() => {
        this.$message.success('点赞成功');
        this.info.discuss_parent.discuss_upvote_times += 1;
        this.show = false;
        this.$forceUpdate();
      });
    },
    dianzanChild (item, index) {
      this.$http({
        url: '/api/v1/discuss/add_upvote',
        method: 'post',
        data: {
          discuss_id: item.discuss_id
        }
      }).then(() => {
        this.$message.success('点赞成功');
        this.info.volist_children[index].discuss_upvote_times += 1;
        this.info.volist_children[index].show = false;
      });
    },
    huifu () {
      let form = {
        discuss_parent_id: this.$route.query.discuss_id,
        discuss_image: [],
        discuss_content: ''
      };
      this.$refs.HuifuFormRef.images = [];
      this.$refs.HuifuFormRef.form = form;
      this.$refs.HuifuFormRef.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner{
  display: flex;
width: 1547rem;
height: 40rem;
padding-top: 10rem;
flex-direction: column;
justify-content: center;
align-items: flex-start;
flex-shrink: 0;
border-radius: 8rem;
background: var(--light-f-5-f-5-f-5, #fff);
}
.info_warp {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: #f6f6f6;
   .textarea{
    // width:  1541rem;
    display: flex;
    flex-direction: column;
     
        background: white;
    padding: 26rem 56rem;
    .images {
  display: flex;
  .add_img{
    img{
      width: 90rem;
      height: 90rem;
      
    }
  }
  div {
    position: relative;
    span {
      position: absolute;
      right: -10rem;
      top: -10rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 30rem;
        height: 30rem;
      }
    }
    margin-right: 20rem;
  }
}
    .btn{
      display: flex;
width: 100rem;
height: 40rem;
color: var(--light-ffffff, #FFF);
text-align: center;
 margin-right: 16rem;
font-size: 24rem;
font-style: normal;
font-weight: 400;
line-height: 36rem; /* 150% */
justify-content: center;
align-items: center;
gap: 8rem;
flex-shrink: 0;
border-radius: 10rem;
border: 1rem solid var(--30-d-0-f-5, #30D0F5);
background: linear-gradient(104deg, #40CCFF 11.83%, #2196F3 100.74%);
    }
  }
  .tiwen {
    box-shadow: 0rem 1rem 5rem 1rem rgba(226, 223, 223, 0.4);
    background: white;
    padding-bottom: 10rem;
    padding: 30rem 40rem  ;
    border-radius: 20rem 20rem 0 0;
    .head {
      display: flex;
      justify-content: space-between;
      width: calc(100% - 64rem);
      margin: 0 auto;
      // border-bottom: 1rem solid #e9e9e9;
      
      height: 79rem;
      align-items: center;
      .text{
       color: var(--light-333333, #333);
font-family: "PingFang SC";
font-size: 18rem;
font-style: normal;
font-weight: 600;
line-height: 24rem; /* 133.333% */
      }
      .subject {
      display: flex;
max-width: 60rem;
// height: 20rem;
padding: 4rem 4rem 4rem 0;
justify-content: center;
align-items: center;
gap: 10rem;
border-radius: 6rem;
background: #F67171;
color: #FFF !important;

 
font-size: 12rem;
font-style: normal;
font-weight: 400;
// line-height: 20rem; /* 166.667% */
      }
      div {
        &:nth-child(1) {
          font-size: 24rem;
          font-weight: bold;
          color: #333333;
          display: flex;
          align-items: center;
          text-indent: 5rem;
          
          img {
            width: 40rem;
            height: 40rem;
            margin-right: 10rem;
          }
        }
        &:nth-child(2) {
          font-size: 12rem;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .content {
      width: calc(100% - 65rem);
      margin: 0 auto;
      margin-top: 17rem;
      font-size: 24rem;
      font-weight: 500;
      color: #333333;
      display: flex;
      flex-direction: column;
    }
    .contentBlock {
      display: block;
    }
    .associated_question {
      padding: 17rem 20rem 0 20rem;
      .header {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .button {
          padding: 6rem;
          display: inline-block;
          font-weight: bold;
          font-size: 24rem;
          color: #3f9eff;
          .button-item {
            display: flex;
            align-items: center;
            div {
              margin-right: 5rem;
            }
          }
        }
      }
      .body {
        font-size: 24rem !important;
        .title {
          position: relative;
          margin: 10rem 7rem;
          font-weight: bold;
          font-size: 24rem;
          height: 30rem;
          text-indent: 10rem;
        }
        // 左边框
        .title::before {
          content: "";
          position: absolute;
          display: inline-block;
          top: 5rem;
          left: -7rem;
          width: 6rem;
          height: 25rem;
          background-color: #2196f3;
        }
        .content {
          margin: 10rem 7rem;
          padding: 7rem;
          line-height: 50rem;
        }
        .border-radius {
          border-bottom: 1rem solid #e9e9e9;
        }
      }
    }
  }

  .common {
    box-shadow: 0rem 1rem 5rem 1rem rgba(226, 223, 223, 0.4);
   
    .huida {
      background: white;
       padding: 0rem 40rem;
      .head {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 40rem);
        margin: 0 auto;
        // border-bottom: 1rem solid #e9e9e9;
        height: 59rem;
        align-items: center;
        div {
          &:nth-child(1) {
            font-size: 24rem;
             gap: 16rem;
            font-weight: bold;
            color: #333333;
            display: flex;
            align-items: center;
            text-indent: 5rem;
            img {
              width: 40rem;
              height: 40rem;
            }
          }
          &:nth-child(2) {
            font-size: 20rem;
            font-weight: 500;
            color: #999999;
          }
        }
      }
      .content {
        width: calc(100% - 40rem);
        margin: 0 auto;
        // margin-top: 17rem;
        font-size: 24rem;
        font-weight: 500;
        color: #333333;
        padding-bottom: 10rem;
        // display: flex;
        
        .btn {
          position: relative;
          display: flex;
          color: #666666;
          font-weight: 500;
          font-size: 16rem;
          display: flex;
          justify-content: space-between;
          .images {
            position: relative;
            img {
              width: 50rem;
              height: 50rem;
              margin-right: 5rem;
            }
          }
          .right {
            position: relative;
            margin-right: 5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16rem;
            gap: 3rem;
            img {
              width: 14rem;
              height: 14rem;
              margin-right: 3rem;
            }
          }
        }
      }
    }
  }
  .fixed_btn {
    width: calc(100% -64rem);
    margin-left: 20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44rem;
    background: #2196f3;
    border-radius: 5rem;
    position: fixed;
    bottom: 20rem;
    font-weight: bold;
    color: #ffffff;
  }
}
.reject_warp {
  display: flex;
  height: 108rem;
  .reject_content {
    flex: 1;

    font-weight: bold;
    font-size: 16rem;
    text-indent: 20rem;
    margin-top: 15rem;
  }
  .reject_btn {
    width: 115rem;
    margin-right: 20rem;
    margin-top: 15rem;
    border-radius: 18rem;
    height: 35rem;
    background: #fedddd;
    font-weight: bold;
    color: #ff664e;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.right {
  // width: 100rem;
  position: relative;
  margin-right: 5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14rem;
  gap: 8rem;
  color: var(--light-999999, #999);
 
font-size: 14rem;
font-style: normal;
font-weight: 400;
line-height: 24rem; /* 171.429% */
  margin-top: 10rem;
  img {
    width: 18rem;
    height: 18rem;
    margin-right: 3rem;
  }
}
 .bottom{
          display: flex;
          justify-content: space-between;
          color: var(--light-999999, #999);
font-family: "PingFang SC";
font-size: 14rem;
font-style: normal;
font-weight: 400;
margin-top: 27rem;
line-height: 24rem; /* 171.429% */
        }
.left {
  flex: 1;
  font-size: 16rem;
}
.wrap {
  height: calc(100vh - 100rem);
  overflow: auto;
  border-radius: 20rem 20rem 0 0;
border-top: 2rem solid #FFF;
border-right: 2rem solid #FFF;
border-left: 2rem solid #FFF;
background: rgba(251, 252, 255, 0.60);
box-shadow: 0 4rem 8rem 0 #B0DCFF;
width: 1740rem;
margin-left: 40rem;
padding: 30rem 40rem;

}
.huifu_btn {
  width: 140rem;
  height: 54rem;
  background: #2196f3;
  border-radius: 35rem;
  font-size: 24rem;
  font-weight: 500;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 40rem;
  top: 23rem;
}

.btn {
  // width: 100rem;
  position: relative;
  display: flex;
  color: #666666;
  font-weight: 500;
  display: flex;
  background: #fff;
  justify-content: space-between;
  .images {
    position: relative;
    img {
      width: 50rem;
      height: 50rem;
      margin-right: 5rem;
    }
  }
}
</style>
